import type { CSSProperties, ReactNode } from 'react'

interface SectionLabelProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

/**
 * SectionLabel — the small mono uppercase eyebrow used above every section
 * ("WHAT HAPPENED", "PRICE COMPARISON"). Wraps the `.section-label` class.
 * Aurora+ source: `.det-sec-label` across s04 / s07 / s12.
 */
export function SectionLabel({ className, style, children }: SectionLabelProps) {
  return (
    <div className={['section-label', className].filter(Boolean).join(' ')} style={style}>
      {children}
    </div>
  )
}
